import React from 'react';
import gql from 'graphql-tag';
import { CheckoutOrderQuantitySelectorFields } from '../schemas/rql';

import FormGroupWithSelect, { ISelectOption } from '@reverbdotcom/commons/src/components/form_group_with_select';
import I18n from 'i18n-js';
import { range } from 'lodash';

interface Props {
  order: CheckoutOrderQuantitySelectorFields.Orders;
  onQuantitySelect(order: { listingId: string, quantity: number }): void;
  disabled?: boolean;
}

export default function CheckoutOrderQuantitySelector(props: Props) {
  const options = buildOptions(props.order);
  const [quantity, setQuantity] = React.useState(props.order.quantity.toString());

  function onQuantitySelect(field: { quantity: any }) {
    setQuantity(field.quantity);
    props.onQuantitySelect({
      listingId: props.order.listingId,
      quantity: field.quantity,
    });
  }

  if (!props.order.buyerCanChangeQuantity) { return null; }

  return (
    <div className="checkout-order-quantity-selector">
      <FormGroupWithSelect
        label={I18n.t('discovery.checkout.orderQuantitySelector.label')}
        inputName="quantity"
        updateField={onQuantitySelect}
        options={options}
        disabled={props.disabled}
        value={quantity}
      />
    </div>
  );
}

function buildOptions(order: CheckoutOrderQuantitySelectorFields.Orders): ISelectOption[] {
  const start = 1;
  const end = order.listing.allowedBuyerQuantity + 1;

  return range(start, end).map((value) => ({
    value: value.toString(),
    text: value.toString(),
  }));
}

export const CheckoutOrderQuantitySelectorFragment = gql`
  fragment CheckoutOrderQuantitySelectorFields on Checkout {
    _id
    orders {
      quantity
      listingId
      buyerCanChangeQuantity
      listing {
        _id
        allowedBuyerQuantity
      }
    }
  }
`;
